import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import Toast from 'vue-toastification'
import axios from 'axios'
import 'vue-toastification/dist/index.css'
import 'boxicons/css/boxicons.min.css'
import './assets/styles/main.css'

// 🚀 Vercel Dev Flag
window.__VERCEL_DEV__ = process.env.VUE_APP_VERCEL_DEV === "true";
window.__VERCEL_ENV__ = "development";

// Configure axios defaults
axios.defaults.withCredentials = true

// Configure baseURL safely - URL RELATIVA por padrão (elimina CORS)
const baseUrl = process.env.VUE_APP_API_URL || ''
axios.defaults.baseURL = baseUrl.replace(/\/+$/, '') // Remove trailing slashes

const app = createApp(App)

const pinia = createPinia()

// Plugin to auto-initialize auth store
pinia.use(({ store }) => {
  if (store.$id === 'auth' && !store.initialized) {
    store.initAuth()
    store.initialized = true
  }
})

app.use(pinia)
app.use(router)

// Reportar pageview ao backend para analytics interno
router.afterEach((to) => {
  axios.post('/api/analytics/pageview', {
    path: to.fullPath,
    referrer: document.referrer,
    title: document.title,
  }).catch(() => {}) // fire-and-forget
})

app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
})

app.mount('#app')
